<div class="container">
    <app-solicitud-servicio [title]="'Aprobación solicitud de servicio'" [$views]="2" 
        [reloadTable]="reloadTable"
        (actionsButtons)="actionBtn = $event"
        (codeSolicitud)="codeSolicitud = $event"
        (solicitudSeleccionadaEmit)="solicitudSeleccionada = $event">
    </app-solicitud-servicio>

    <div class="container d-flex flex-row justify-content-end gap-2" *ngIf="actionBtn">
        <button class="btn btn-secondary col-2" (click)="onAprobar()">APROBAR</button>
        <button class="btn btn-secondary col-2" (click)="onRechazar()">RECHAZAR</button>
        <button class="btn btn-secondary col-2" (click)="onValidate(validate)">VALIDACION DE DATOS</button>
        <button class="btn btn-secondary col-2" (click)="onCancel(cancel)">CANCELAR SOLICITUD</button>
    </div>

    <br>
</div>




<!-- ==================================================================================================================== -->
<!-- ==================================================================================================================== -->

<!-- MODAL VALIDACIÓN DE DATOS -->

<ng-template #validate let-c="close" let-d="dismiss">
    <div class="modal-header">
        <h4 class="modal-title text-secondary" id="modal-basic-title">
            <strong class="text-secondary">Validación de datos solicitud del servicio</strong>
        </h4>
    </div>

    <div class="modal-body py-3">
        <app-validacion-datos-solicitud-servicio 
            [codeSolicitud]="codeSolicitud" 
            (cancel)="onValidate($event)"
            (reloadTable)="reloadTable = $event">
        </app-validacion-datos-solicitud-servicio>
    </div>
</ng-template>




<!-- MODAL CANCELACION DE LA SOLICITUD DEL SERVICIO -->

<ng-template #cancel let-c="close" let-d="dismiss">
    <div class="modal-header">
        <h4 class="modal-title text-secondary" id="modal-basic-title">
            <strong class="text-secondary">Cancelación de la solicitud del servicio</strong>
        </h4>
        <!-- <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" (click)="d('Cross click')"></button> -->
    </div>

    <div class="modal-body py-3">
        <app-cancelar-solicitud-servicio
            [codeSolicitud]="codeSolicitud"
            [solicitudSeleccionada]="solicitudSeleccionada"
            (cancel)="onValidate($event)"
            (reloadTable)="reloadTable = $event">
        </app-cancelar-solicitud-servicio>
    </div>
</ng-template>